import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { CommonPostResponse } from '../../../components/models/models'
import { IPostAuthorizedServicesProcedur } from '../models/models'

export class PutAuthorizedServicesProcedurApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesProcedur/update',
      requesterInfo,
    })
  }

  public async putAuthorizedServicesProcedur(request: any): Promise<CommonPostResponse> {
    return await this.putAsync<CommonPostResponse>(undefined, request)
  }
}
